import React from 'react';
import { GenericPortalLayout } from 'portal-core/components/layout/page/GenericPortalLayout';

export function ConsumerPortalLayout(props) {
  return <GenericPortalLayout {...props} />;
}
